<template>
    <div class="user-shipment">
        <div class="columns" style="margin-bottom: 60px">
            <div class="column font-apercu-bold is-size-4 is-11">
                {{ $t("My Addresses") }}
            </div>
            <div class="column is-size-4 right is-3">
                <button
                    class="button"
                    @click="activeAddressModal(true, false, 0)"
                >
                    {{ $t("Add new address") }}
                </button>
            </div>
        </div>
        <div id="main-card" v-if="address.data.length" class="table">
            <b-table
                :loading="loading"
                :data="address.data"
                :pagination-simple="false"
                pagination-size="is-small"
                :total="address.total"
                :paginated="true"
                backend-pagination
                :per-page="10"
                @page-change="onPageChange"
            >
                <template slot-scope="props">
                    <b-table-column field="name" :label="$t('Name')">
                        <div class="td-spacer">
                            <div class="areas">
                                <div class="name">
                                    {{ props.row.full_name }}
                                </div>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column field="country" :label="$t('Country')">
                        <div class="td-spacer">
                            <div class="areas">
                                <div class="name">
                                    {{ props.row.country.name }}
                                </div>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column field="city" :label="$t('City')">
                        <div class="td-spacer">
                            <div class="areas">
                                <div class="name">{{ props.row.city }}</div>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column field="mobile" :label="$t('Phone Number')">
                        <div class="td-spacer">
                            <div class="areas">
                                <div class="name">{{ props.row.mobile }}</div>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column field="actions" :label="$t('Options')">
                        <div class="level">
                            <div
                                class="level-item"
                                style="justify-content: start"
                            >
                                <!-- <b-tooltip label="Edit Address">
                                    <span
                                        class="actions"
                                        @click="
                                            activeAddressModal(
                                                true,
                                                true,
                                                props.row.id
                                            )
                                        "
                                    >
                                        <b-icon
                                            icon="pencil"
                                            type="is-light"
                                        ></b-icon>
                                    </span>
                                </b-tooltip> -->
                                <b-tooltip label="Delete Address">
                                    <span
                                        class="actions"
                                        @click="
                                            (isDeleteAddressModalActive = true),
                                                (currentClickedAddressID =
                                                    props.row.id)
                                        "
                                    >
                                        <b-icon
                                            icon="delete"
                                            type="is-light"
                                        ></b-icon>
                                    </span>
                                </b-tooltip>
                            </div>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
        <div v-else>
            <p>
                {{ $t("You don't have shipments yet,") }}
                <router-link :to="{ name: 'send-shipment' }">
                    <span class="has-text-primary" style="cursor: pointer">{{
                        $t("Start Now")
                    }}</span>
                </router-link>
            </p>
        </div>

        <b-modal
            :active.sync="isAddressModalActive"
            trap-focus
            aria-role="dialog"
            aria-modal
            scroll="clip"
        >
            <AddAddress
                :addressData="
                    passData ? addressDataPerID(currentClickedAddressID) : null
                "
            />
        </b-modal>

        <b-modal
            :active.sync="isDeleteAddressModalActive"
            trap-focus
            aria-role="dialog"
            aria-modal
            scroll="clip"
        >
            <div class="modal-card text-center">
                <section class="modal-card-body">
                    <p>{{ $t("Do You want to delete address") }}</p>

                    <button
                        class="button is-primary"
                        @click="removeAddress(currentClickedAddressID)"
                    >
                        {{ $t("Yes") }}
                    </button>
                    <button
                        class="button"
                        @click="isDeleteAddressModalActive = false"
                    >
                        {{ $t("No") }}
                    </button>
                </section>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { http, API } from "@/store/API";
import { downladFileMixin } from "@/components/Mixins/downloadFileMixin";
import AddAddress from "@/components/modal/AddAddress.vue";

export default {
    mixins: [downladFileMixin],
    components: {
        AddAddress,
    },
    data() {
        return {
            loading: false,
            isAddressModalActive: false,
            isDeleteAddressModalActive: false,
            passData: false,
            currentClickedAddressID: 0,
            API,
        };
    },
    methods: {
        onPageChange(page) {
            this.callAddress(page);
        },
        removeAddress(currentAddressID) {
            this.$store
                .dispatch("deleteAddress", currentAddressID)
                .then((res) => {
                    if (res.status === 200) {
                        this.callAddress();
                    }
                });
            this.isDeleteAddressModalActive = false;
        },
        callAddress(currentPage) {
            this.loading = true;
            this.$store
                .dispatch("address", currentPage ? currentPage : 1)
                .then(() => {
                    this.loading = false;
                });
        },
        activeAddressModal(modalActive, passDataActive, addressID) {
            this.isAddressModalActive = modalActive;
            this.passData = passDataActive;
            this.currentClickedAddressID = addressID;
        },
        addressDataPerID(addressID) {
            return this.address.data.filter(
                (address) => address.id === addressID
            );
        },
    },
    computed: {
        address() {
            return this.$store.state.addressBook;
        },
    },
    created() {
        this.callAddress();
    },
};
</script>
<style lang="scss" scoped>
.level {
    height: 50px !important;
    padding-bottom: 0 !important;

    .view-order {
        font-size: 0.78rem;
        display: inline-block;
        text-align: center;
        background-color: #93a2dd;
        color: white;
        padding: 2px 4px;
        margin-right: 15px;
        cursor: pointer;
        border-radius: 5px;

        &:hover {
            background-color: #5d78ff !important;
        }
    }
}
.td-spacer {
    padding: 5px 0;
}

.areas {
    .address {
        color: #737373;
        text-transform: capitalize;
        font-size: 0.85rem;
    }
}

.status {
    font-size: 0.78rem;
    display: inline-block;
    background-color: #93a2dd;
    color: #000;
    padding: 3px 10px;
    border-radius: 50px;
}

::v-deep {
    .table {
        margin-top: 40px;
        padding: 0 30px;

        table {
            width: 100%;
            thead {
                background: #f7f7f7;
                border-radius: 5px;
            }
            th {
                padding-top: 11px;
                padding-bottom: 11px;
            }
            tbody {
                tr {
                    border-bottom: 1px solid #ddd;
                    height: 60px;
                    // &:last-of-type {
                    //     border: none;
                    // }

                    td {
                        border-bottom: 2px solid #f7f8fa !important;
                        vertical-align: middle;
                    }
                }
            }

            .total {
                font-weight: bold;
                text-align: center;
            }
            .primary {
                color: #4952ff;
                font-weight: bold;
            }

            .danger {
                color: #ff7977;
                font-weight: bold;
            }
            .text-center {
                text-align: center;
            }
        }
    }
}

.actions {
    color: #93a2dd;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;

    &:hover {
        color: #5d78ff !important;
    }
}

.dropdown-icons {
    margin-right: 15px;
    display: inline-block;
}

.plus-icon {
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    background: #5d78ff;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    margin: auto;
    font-weight: bold;
    font-size: 25px;
    color: white;
    &:hover {
        opacity: 0.7;
    }
    span {
        margin: auto;
    }
}
::v-deep {
    .modal-card-body {
        text-align: center;
        button {
            margin: 10px;
            width: 100px;
        }
    }
    .modal-background {
        background-color: rgba(10, 10, 10, 0.36);
    }
}
.modal .animation-content .modal-card {
    margin: 0;
    margin: auto;
}
</style>
